import { render, staticRenderFns } from "./Chartjs.vue?vue&type=template&id=4b5c8f8c&"
import script from "./Chartjs.vue?vue&type=script&lang=js&"
export * from "./Chartjs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b5c8f8c')) {
      api.createRecord('4b5c8f8c', component.options)
    } else {
      api.reload('4b5c8f8c', component.options)
    }
    module.hot.accept("./Chartjs.vue?vue&type=template&id=4b5c8f8c&", function () {
      api.rerender('4b5c8f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/admin/charts/Chartjs.vue"
export default component.exports